/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import e from "prop-types";
const r = e.exact({
  left: e.number,
  top: e.number
}), i = {
  left: e.number,
  right: e.number
}, l = {
  ...i,
  top: e.number,
  bottom: e.number
}, t = e.oneOfType([e.number, e.exact(l)]), n = t, o = e.exact({
  width: e.number,
  color: e.string,
  opacity: e.number,
  dashType: e.string
}), a = {
  visible: e.bool,
  font: e.string,
  color: e.string,
  opacity: e.number,
  align: e.oneOf(["left", "right", "center"]),
  position: e.oneOf(["inside", "before", "after"]),
  padding: n,
  margin: e.exact(i),
  border: o,
  offset: r
}, s = {
  color: e.string,
  opacity: e.number,
  offset: r,
  padding: e.number,
  width: e.number,
  focusHighlight: e.exact({
    border: o
  })
}, c = {
  colorType: e.oneOf(["static", "source", "target"]),
  color: e.string,
  opacity: e.number,
  highlight: e.exact({
    opacity: e.number,
    inactiveOpacity: e.number
  }),
  focusHighlight: e.exact({
    border: o
  })
}, b = e.exact({
  text: e.string,
  ...a
}), p = e.exact({
  id: e.oneOfType([e.string, e.number]).isRequired,
  label: b.isRequired,
  ...s
}), u = e.exact({
  sourceId: e.oneOfType([e.string, e.number]).isRequired,
  targetId: e.oneOfType([e.string, e.number]).isRequired,
  value: e.number.isRequired,
  ...c
}), f = {
  data: e.exact({
    nodes: e.arrayOf(p.isRequired).isRequired,
    links: e.arrayOf(u.isRequired).isRequired
  }).isRequired,
  links: e.exact(c),
  nodes: e.exact(s),
  labels: e.exact(a),
  legend: e.exact({
    align: e.oneOf(["start", "center", "end"]),
    background: e.string,
    border: o,
    height: e.number,
    labels: e.object,
    margin: t,
    offsetX: e.number,
    offsetY: e.number,
    orientation: e.oneOf(["vertical", "horizontal"]),
    padding: n,
    position: e.oneOf(["top", "bottom", "left", "right", "custom"]),
    reverse: e.bool,
    visible: e.bool,
    width: e.number,
    item: e.object,
    title: e.object
  }),
  title: e.exact({
    align: e.oneOf(["center", "left", "right"]),
    background: e.string,
    border: o,
    color: e.string,
    font: e.string,
    margin: t,
    padding: n,
    position: e.oneOf(["top", "bottom"]),
    text: e.string,
    visible: e.bool
  }),
  tooltip: e.exact({
    visible: e.bool,
    appendTo: e.any,
    offset: e.number,
    followPointer: e.bool,
    delay: e.number,
    linkComponent: e.any,
    nodeComponent: e.any
  }),
  className: e.string,
  style: e.object,
  dir: e.string,
  disableAutoLayout: e.bool,
  disableKeyboardNavigation: e.bool,
  onNodeEnter: e.func,
  onNodeLeave: e.func,
  onLinkEnter: e.func,
  onLinkLeave: e.func,
  onNodeClick: e.func,
  onLinkClick: e.func
};
export {
  f as sankeyPropTypes
};
